import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 1 }

import { ref, watch, onMounted, nextTick, toRefs, computed, inject } from 'vue';
import { isMobile, isTablet } from 'mobile-device-detect';
import { Settings } from '../constant';
import PlusCircleIcon from '@/assets/icons/PlusCircle.vue';
import MinusCircleIcon from '@/assets/icons/MinusCircle.vue';
import PrinterIcon from '@/assets/icons/Printer.vue';

interface Props {
  zoomInDisabled?: boolean;
  zoomOutDisabled?: boolean;
  headerOpen: boolean;
  isKioskMode: boolean;
  toolbar: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppToolBar',
  props: {
    zoomInDisabled: { type: Boolean },
    zoomOutDisabled: { type: Boolean },
    headerOpen: { type: Boolean },
    isKioskMode: { type: Boolean },
    toolbar: { type: Boolean }
  },
  emits: [
  'zoomIn',
  'zoomOut',
  'handlePrintClick',
  'calculateContactInfoTopPosition',
  'autoFit',
  'toggleToolbar',
],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const {
  zoomInDisabled,
  zoomOutDisabled,
  headerOpen,
  isKioskMode,
  toolbar,
} = toRefs(props);

const emit = __emit;

// injector
const showDivisionCommunityDropdown = inject('setSelectionDropdown', ref(false));

const toolbarTopPosition = ref(0);
const autoZoom = ref(false);

const zoomIn = () => emit('zoomIn');
const zoomOut = () => emit('zoomOut');

const handlePrintClick = () => {
  calculateContactInfoTopPosition();
  emit('handlePrintClick');
};

const calculateContactInfoTopPosition = () =>
  emit('calculateContactInfoTopPosition');

const autoFit = () => {
  autoZoom.value = !autoZoom.value;
  emit('autoFit');
};

const toggleToolbar = () => emit('toggleToolbar');

const calculateToolbarTopPosition = () => {
  const outerHeight =
    isMobile && !isTablet
      ? Settings.TOP_OUTER_HEIGHT_MOBILE
      : Settings.TOP_OUTER_HEIGHT_TABLET;
  const header = document.getElementById('header') as HTMLElement;
  toolbarTopPosition.value =
    (header && header.clientHeight
      ? header.clientHeight
      : Settings.TOP_OUTER_HEIGHT_TABLET) + outerHeight;
};

watch(
  zoomInDisabled,
  (disabled) => {
    nextTick(() => {
      const zoomInEl = document.querySelector('.zoom_in') as HTMLDivElement;
      if (zoomInEl) {
        zoomInEl.style.pointerEvents = disabled ? 'none' : 'auto';
        zoomInEl.style.opacity = disabled ? '0.5' : '1';
      }
    });
  },
  { immediate: true }
);

watch(
  zoomOutDisabled,
  (disabled) => {
    nextTick(() => {
      const zoomOutEl = document.querySelector('.zoom_out') as HTMLDivElement;
      if (zoomOutEl) {
        zoomOutEl.style.pointerEvents = disabled ? 'none' : 'auto';
        zoomOutEl.style.opacity = disabled ? '0.5' : '1';
      }
    });
  },
  { immediate: true }
);

watch(headerOpen, (newVal, oldVal) => {
  if (newVal !== oldVal) calculateToolbarTopPosition();
});

onMounted(() => {
  calculateToolbarTopPosition();
});
__expose({
  calculateToolbarTopPosition,
});

const isHorizontal = computed(() => {
  
  return showDivisionCommunityDropdown.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ top: `${toolbarTopPosition.value}px` }),
    class: "embtoolbox"
  }, [
    (!_unref(toolbar))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: toggleToolbar
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "icon icon-header-collapsed" }, [
            _createElementVNode("span", { class: "path1" }),
            _createElementVNode("span", { class: "path2" })
          ], -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["emb-card", isHorizontal.value ? 'flexRow' : 'flexCol'])
        }, [
          (!_unref(isKioskMode) && !isHorizontal.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "dsize tbIcon",
                onClick: handlePrintClick
              }, [
                _createVNode(PrinterIcon)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "dsize tbIcon zoom_in",
            onClick: zoomIn
          }, [
            _createVNode(PlusCircleIcon)
          ]),
          _createElementVNode("div", {
            class: "dsize tbIcon zoom_out",
            onClick: zoomOut
          }, [
            _createVNode(MinusCircleIcon)
          ]),
          (isHorizontal.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, "|"))
            : _createCommentVNode("", true),
          (!_unref(isKioskMode) && isHorizontal.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "dsize tbIcon",
                onClick: handlePrintClick
              }, [
                _createVNode(PrinterIcon)
              ]))
            : _createCommentVNode("", true)
        ], 2))
  ], 4))
}
}

})